import { render, staticRenderFns } from "./LPBgArrow.vue?vue&type=template&id=29353d54"
import script from "./LPBgArrow.vue?vue&type=script&lang=ts&setup=true"
export * from "./LPBgArrow.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports